import apiV2 from '../api/v2';
import type { DmMessageFrustration, DmMessageUrgency } from './dmMessagesInbox';

export type OverviewLevel = 'alert' | 'warning' | 'info' | 'other' | 'none';
export type OverviewAgeBucket = 'under1d' | '1to3d' | '3to7d' | 'over7d';
export type OverviewCategory = 'notification' | 'message';

export interface OverviewOpenTotals {
    notifications: number;
    messages: number;
    patients: number;
    notificationPatients: number;
    messagePatients: number;
}

export interface OverviewAgeBucketCounts {
    bucket: OverviewAgeBucket;
    notifications: number;
    messages: number;
}

export interface OverviewAge {
    buckets: OverviewAgeBucketCounts[];
    oldestNotificationAt: string | null;
    oldestMessageAt: string | null;
}

export interface OverviewAssignee {
    // Null for the Unassigned group.
    userId: string | null;
    name: string | null;
    email: string | null;
    patients: number;
    notifications: number;
    messages: number;
}

export interface OverviewTriage {
    priority: { value: DmMessageUrgency; count: number }[];
    frustration: { value: DmMessageFrustration; count: number }[];
}

export interface MonitoringOverview {
    generatedAt: string;
    open: OverviewOpenTotals;
    levels: { level: OverviewLevel; count: number }[];
    eventTypes: { eventType: string; count: number }[];
    age: OverviewAge;
    assignees: OverviewAssignee[];
    triage: OverviewTriage;
}

export const fetchMonitoringOverview = async (): Promise<MonitoringOverview> => {
    const response = await apiV2.get<{ success: boolean; data: MonitoringOverview }>(
        '/admin/monitoring/overview'
    );
    return response.data.data;
};
